import React, { useState, useEffect } from "react";
import Footer from "../Footer/footer";
import Header from "../Header/header";
import MujallahHighlights from "./MujallahHighlights";
import { getMujallah, getMujallahById } from "./_request";
import reading from "../../Assets/images/reading.svg";
import shairy from "../../Assets/images/shairy.svg";
import MujallahCarousel from "./MujallahCarousel";
import { imageUrl } from "../../const/constants";

const Mujallah = () => {
  const [mujallahData, setMujallahData] = useState([]);
  const [selectedMujallah, setSelectedMujallah] = useState(null);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const MUJALLAH_PDF_URL = `${imageUrl}/mujjalahPdfs`;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getMujallah();
        if (response.Result) {
          const sorted = [...response.Mujjallah].sort(
            (a, b) => parseInt(b.mujjalah.year) - parseInt(a.mujjalah.year),
          );
          setMujallahData(sorted);
          const latest = sorted[0]?.mujjalah;
          setSelectedMujallah(latest);
          if (latest?.id) {
            const articlesResponse = await getMujallahById(latest.id);
            if (articlesResponse.Result) {
              setArticles(articlesResponse.Articles || []);
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // const handleMujallahClick = async (mujallah) => {
  //     setSelectedMujallah(mujallah);
  //     setLoading(true);
  //     try {
  //         const response = await getMujallahById(mujallah.id);
  //         if (response.Result) {
  //             setArticles(response.Articles || []);
  //         } else {
  //             setArticles([]);
  //         }
  //     } catch (error) {
  //         console.error(error);
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  const groupArticles = (articles) => {
    const grouped = [];
    const chunkSize = 3;
    for (let i = 0; i < articles.length; i += chunkSize) {
      grouped.push(articles.slice(i, i + chunkSize));
    }
    return grouped;
  };

  // Filter out the active article if an id is provided (e.g., via prop or state)
  const filteredArticles = selectedMujallah?.activeArticleId
    ? articles.filter(
        (article) =>
          String(article.id) !== String(selectedMujallah.activeArticleId),
      )
    : articles;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
      </div>
    );
  }
  const handleMujallahSelect = async (mujallah) => {
    if (mujallah?.id === selectedMujallah?.id) return;

    setLoading(true);
    try {
      const detailed = await getMujallahById(mujallah.id);
      if (detailed?.Result) {
        setSelectedMujallah(detailed.Mujjalah);
        setArticles(detailed.Articles || []);
      }
    } catch (err) {
      console.error("Failed to fetch selected diary data", err);
    } finally {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setLoading(false);
    }
  };
  return (
    <>
      <Header />
      <div className="bg-white min-h-screen w-full mt-5 px-5 sm:px-10 md:px-10 lg:px-20 text-black text-center font-nastaleeqRegular font-normal">
        <div className="pt-10 sm:pt-16 md:pt-20">
          {/* Year Switcher */}
          {/* <div className="flex flex-wrap justify-center gap-4 rtl mb-8">
                        {mujallahData.map(({ mujjalah }) => (
                            <button
                                key={mujjalah.id}
                                onClick={() => handleMujallahClick(mujjalah)}
                                className={`rounded-xl border-2 px-4 py-2 text-lg sm:text-xl md:text-2xl lg:text-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg
                                    ${selectedMujallah?.id === mujjalah.id
                                        ? 'bg-primary text-white border-primary'
                                        : 'border-primary text-primary hover:bg-primary hover:text-white'}`}
                            >
                                {mujjalah.year} ہـ
                            </button>
                        ))}
                    </div> */}

          <div className="bg-primaryBG rounded-3xl py-8 sm:py-10 md:py-12 px-5 sm:px-10 md:px-20">
            <MujallahHighlights mujallah={selectedMujallah} />
          </div>

          {/* موضوعات Section */}
          {filteredArticles.length > 0 && (
            <div className="flex flex-col items-center mt-12 transition-all duration-300">
              <p className="font-nastaleeqRegular text-2xl sm:text-3xl md:text-4xl lg:text-4xl font-normal mb-6 transition-colors duration-300 hover:text-primary">
                موضوعات
              </p>
              <div className="flex flex-row-reverse justify-around align-middle rtl w-full max-w-screen-lg">
                {groupArticles(filteredArticles).map((group, index) => (
                  <ul
                    key={index}
                    className="font-nastaleeqRegular list-disc list-inside p-2 text-right text-lg sm:text-xl md:text-xl lg:text-2xl leading-10 transition-all duration-300 hover:shadow-lg rounded-xl"
                    dir="rtl"
                  >
                    {group.map((article) => (
                      <li
                        key={article.id}
                        className="hover:text-primary transition-all duration-300 hover:scale-105 cursor-pointer"
                      >
                        {article.title}
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
            </div>
          )}

          {/* خصوصیات */}
          <div className="bg-primaryBG flex flex-col items-center gap-y-8 py-10 px-8 sm:px-12 md:px-16 lg:px-[121px] rounded-3xl mt-12">
            <h1 className="font-nastaleeqKasheeda text-2xl sm:text-3xl md:text-4xl lg:text-4xl text-center">
              مجلہ کی مختلف خصوصیات
            </h1>
            <div className="flex flex-wrap flex-row-reverse justify-center gap-8 sm:gap-12 md:gap-16 lg:gap-20 w-full">
              <div className="flex flex-col gap-4 items-center">
                <img
                  src={reading}
                  alt="Reading Icon"
                  className="h-20"
                  loading="lazy"
                />
                <h2 className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda text-center">
                  تازہ ترین مضامین
                </h2>
              </div>
              <div className="flex flex-col gap-4 items-center">
                <img
                  src={shairy}
                  alt="Shairy Icon"
                  className="h-20"
                  loading="lazy"
                />
                <h2 className="text-lg sm:text-xl md:text-xl lg:text-2xl font-nastaleeqKasheeda text-center">
                  موضوعات پر شاعری
                </h2>
              </div>
            </div>
          </div>

          {/* 📖 Muqadma Section */}
          {(() => {
            // Check if muqadma exists and has actual text content (not just HTML tags)
            if (!selectedMujallah?.muqadma || typeof selectedMujallah.muqadma !== 'string') return null;
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = selectedMujallah.muqadma;
            const textContent = tempDiv.textContent || tempDiv.innerText || '';
            if (!textContent.trim()) return null;
            
            return (
              <div className="flex flex-col items-center mt-12 mb-20">
                <p className="font-nastaleeqRegular text-2xl sm:text-3xl md:text-4xl lg:text-4xl mb-3">
                  مقدمہ
                </p>
                <div
                  className="w-full text-center text-lg sm:text-xl md:text-xl lg:text-2xl p-6 rounded-3xl group"
                  dangerouslySetInnerHTML={{ __html: selectedMujallah.muqadma }}
                />
              </div>
            );
          })()}

          {/* Mujallah PDF */}
          {loading || !selectedMujallah ? (
            <div className="flex justify-center items-center h-24 mt-12">
              <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
            </div>
          ) : selectedMujallah.pdf ? (
            <div className="w-full h-[850px] flex justify-center mt-8 transition-all duration-300 hover:shadow-lg rounded-3xl overflow-hidden">
              <iframe
                src={`${MUJALLAH_PDF_URL}/${selectedMujallah.pdf}`}
                className="w-full h-[850px] transition-all duration-300"
                title="Mujallah PDF"
                allowFullScreen
              ></iframe>
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8 mt-12">
              پی ڈی ایف دستیاب نہیں
            </div>
          )}
          <div className="p-4">
            <MujallahCarousel
              mujallahs={mujallahData}
              selectedMujallah={selectedMujallah}
              handleMujallahSelect={handleMujallahSelect}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Mujallah;
